<template>
  <video v-bind="videoAttrs" :class="classes">
    <source :src="staticUrl" type="video/mp4" />
  </video>
</template>

<script>
export default {
  name: 'BrbVideo',
  inheritAttrs: false,
  props: {
    src: { type: String, default: null },
    thumbor: { type: Boolean, default: false },
    format: { type: String, default: 'mp4' },
    fitIn: { type: Boolean, default: false },
    width: { type: [Number, String], default: null },
    height: { type: [Number, String], default: null },
    lazy: { type: Boolean, default: false },
    fluid: { type: Boolean, default: true },
    fluidGrow: { type: Boolean, default: false },
    poster: {
      type: String,
      default: function () {
        return this.$config.files.imagePlaceholderUrl
      }
    },
    effects: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      webmSupportVersion: {
        Chrome: 31,
        Firefox: 64,
        Edge: 17,
        Safari: 14
      }
    }
  },
  computed: {
    classes() {
      return {
        'd-block': true,
        'img-fluid': this.fluid,
        'w-100': this.fluidGrow
      }
    },
    videoAttrs() {
      return {
        autoplay: true,
        loop: true,
        muted: true,
        width: this.width,
        height: this.height,
        ...this.$attrs
      }
    },
    staticUrl() {
      return this.$config.files.createStaticUrl(this.src)
    },
    webpCompatible() {
      const browser = this.$browserDetect.meta.name
      const browserVersion = this.$browserDetect.meta.version.split('.')[0]
      return browserVersion > this.webpBrowserMinVersion[browser]
    },
    thumborConfig() {
      return {
        src: this.src,
        fitIn: this.fitIn,
        width: this.width,
        height: this.height,
        effects: this.effects || {},
        webpCompatible: this.webpCompatible,
        format: this.format
      }
    },
    mediaSrc() {
      if (!this.src) {
        if (this.showNoImage) return this.noImageUrl
        return null
      }

      // in external url case dont use thumbor
      if (this.src.startsWith('http')) return this.src

      if (this.thumbor && this.$config.files.thumbor.enabled) {
        return this.thumbUrl
      }

      return this.staticUrl
    },
    thumbUrl() {
      return this.$config.files.thumbor.createUrl(this.thumborConfig)
    }
  }
}
</script>